import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

interface Progress {
  done: number;
  total: number;
}

export const demandProgressApi = createApi({
  reducerPath: 'demandProgressApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['DemandProgress'] as const,
  endpoints: (builder) => ({
    getProgress: builder.query<Progress, string>({
      query: (matterId) => `api/matters/${matterId}/demand-progress/`,
      providesTags: (_r, _e, matterId) => [
        { type: 'DemandProgress', id: matterId },
      ],
    }),
  }),
});

export const { useGetProgressQuery } = demandProgressApi;
